import oneplatformImg from "../assets/One-Platform-1.webp";
import One1 from "../assets/One-2.webp";
import One2 from "../assets/One-3.webp";
import Btn from "../resuable-components/Button";
import { trackSignupEvent } from '../../../utlis/useAnalytics'; // adjust path

export default function Oneplatform() {

  const btnClick = () => {
    trackSignupEvent( {
      page: 'Global Collection Page',
      section: 'One Platform SignUp',
    });
  };

  return (
    <div className="bg-[#1d2939] lg:px-[10%] font-bold mt-[140px] pt-20 pb-20">
      {/* Header */}
      <p className="text-white  text-center text-4xl px-4 pb-5">
        One Platform to manage your entire business
      </p>

      {/* Main section with image */}
      <div className="rounded-2xl bg-[#273242] p-4 ml-[3%]  mr-[3%] flex flex-col md:flex-row items-center justify-center gap-x-10 mt-10 px-4 ">
        <div className="text-center md:text-left  rounded-2xl p-5">
          <p className="text-white text-3xl md:text-3xl ">Transparency all the way</p>
          <p className="mt-10 text-[#abafb6]">
            Track payments in real-time with zero forex markup and complete cost transparency.
          </p>
        </div>
        <img src={oneplatformImg} className="mt-10 md:mt-1 md:w-[50%] object-contain mx-auto" loading="lazy" />
      </div>

      {/* Grid section */}
      <div className="mt-20 px-4 md:px-[3%] grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="bg-[#273242] rounded-2xl p-5 text-center md:text-left">
          <p className="text-white text-2xl">Instant e-FIRA for Hassle-Free Compliance</p>
          <p className="text-[#abafb6] mt-2 md:pr-[40%]">
            Simplify exports — stay compliant and claim GST refunds effortlessly.
          </p>
          <img src={One1} className="mt-10 w-[80%] mx-auto" loading="lazy" />
        </div>
        <div className="bg-[#273242] rounded-2xl p-5 text-center md:text-left">
          <p className="text-white text-2xl">Stay on Top of Your Invoices & Revenue</p>
          <p className="text-[#abafb6] mt-2 md:pr-[30%]">
            Easily track payments, overdue invoices, and monthly revenue in one place.
          </p>
          <img src={One2} className="mt-10 w-[80%] mx-auto" loading="lazy"/>
        </div>
      </div>

      {/* Sign Up Button */}
      <div className="flex mt-10 justify-center">
          <Btn onClick={btnClick}/>
      </div>
    </div>
  );
}
